import { render, staticRenderFns } from "./general.vue?vue&type=template&id=22a18dce&"
import script from "./general.vue?vue&type=script&lang=js&"
export * from "./general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a18dce')) {
      api.createRecord('22a18dce', component.options)
    } else {
      api.reload('22a18dce', component.options)
    }
    module.hot.accept("./general.vue?vue&type=template&id=22a18dce&", function () {
      api.rerender('22a18dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/tabs/general.vue"
export default component.exports